import Vue from 'vue'
//用作页面之前传递函数的中转
export default new Vue
